export enum SUB_ACTION_TYPE_ENUMS {
  EXISTS = 'exists',
  GOT_PLANS = 'got_plans',
  NO_SUB_EXIST = 'NO_SUB_EXIST',
}
